import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../../actions/authenticationActions';
import Logout from './Logout';
import './Logout.scss';

@connect(null, {
	logout,
})
export default class LogoutContainer extends Component {
	render() {
		const { logout } = this.props;
		return (
			<div className="onboarding__logout-container">
				<Logout logout={logout} />
			</div>
		);
	}
}
